export default __webpack_public_path__ + "static/media/right-img-2.ba1b8f48.png";